function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n\n  a {\n    word-break: break-word;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  filter: ",
        ";\n  color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n  margin-right: 5px;\n  margin-top: 5px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  align-self: end;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  flex: 0 0 auto;\n  gap: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 30px;\n\n  &:first-of-type {\n    margin-top: 0;\n  }\n\n  .product-details-bundle-name {\n    color: ",
        ";\n  }\n\n  .product-details-bundle-description {\n    font-size: 1em;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: 5px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
import React, { Fragment, PureComponent } from "react";
import propTypes from "prop-types";
import { Flipper } from "react-flip-toolkit";
import styled from "styled-components";
import { Form } from "formik";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import { GiTwoCoins } from "react-icons/gi";
import { Row, SpacedCol, Col } from "../../../grid";
import Effect from "../../../formik-effect";
import Card from "../../../card";
import Link from "../../../link";
import { MediumText, ErrorText } from "../../../text";
import Tabs, { Tab } from "../../../tabs";
import Button from "../../../button";
import i18n, { getLocalizedProperty } from "../../../../utils/i18n";
import ProductRow from "../product-row";
import formatCurrency from "../../../../utils/format-currency";
import tryCall from "../../../../utils/try-call";
import { withContext, context } from "../../../wr-context";
import Carousel from "../../../carousel";
import { isArray } from "lodash";
var ProductData = styled.div(_templateObject());
var HeaderLabels = styled.div(_templateObject1());
var HeaderLabel = styled.span(_templateObject2(), function(param) {
    var theme = param.theme, index = param.index;
    return theme.components.productDetails.headerRows.colors[index - 1] ? theme.components.productDetails.headerRows.colors[index - 1].backgroundColor : theme.palette.primary;
}, function(param) {
    var theme = param.theme, index = param.index;
    return theme.components.productDetails.headerRows.colors[index - 1] ? theme.components.productDetails.headerRows.colors[index - 1].filter : "brightness(1.".concat((index / 2).toString().replace(".", ""), ")");
}, function(param) {
    var theme = param.theme, index = param.index;
    return theme.components.productDetails.headerRows.colors[index - 1] ? theme.components.productDetails.headerRows.colors[index - 1].color : "#fff";
}, function(param) {
    var theme = param.theme;
    return theme.components.productDetails.headerRows.borderRadius;
}, function(param) {
    var theme = param.theme;
    return theme.components.productDetails.headerRows.padding;
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor && "\n      background: ".concat(backgroundColor, "\n  ");
});
var AddToProduct = styled.div(_templateObject3());
var ResetAndAddContainer = styled.div(_templateObject4());
var TabsContainer = styled.div(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.palette.primary;
});
var CoinIcon = styled.span(_templateObject6());
var processHeaderLabels = function() {
    var headerRows = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var labels = [];
    headerRows.forEach(function(row) {
        if (Array.isArray(row.control)) {
            row.control.forEach(function(cont) {
                var currentLabel = typeof cont === "string" ? JSON.parse(cont) : cont;
                labels.push({
                    label: currentLabel.label,
                    rowLabel: row.label
                });
            });
        } else if (typeof row.control !== "string") {
            if (row.control && row.control.label) {
                labels.push({
                    label: row.control.label,
                    rowLabel: row.label
                });
            }
        } else {
            labels.push({
                label: row.control,
                rowLabel: row.label
            });
        }
    });
    return labels;
};
var ProductCard = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ProductCard, PureComponent);
    var _super = _createSuper(ProductCard);
    function ProductCard() {
        _classCallCheck(this, ProductCard);
        var _this;
        _this = _super.apply(this, arguments);
        _this.toggleProduct = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _props = _this.props, enableValidation = _props.enableValidation, validateCart = _props.validateCart, formik = _props.formik, toggleProduct = _props.toggleProduct, addToCartSubmits = _props.addToCartSubmits, addToCartAlways = _props.addToCartAlways, shouldResetOnAdd = _props.shouldResetOnAdd;
            if (addToCartSubmits) {
                formik.submitForm();
            }
            if (addToCartAlways) {
                toggleProduct.apply(void 0, _toConsumableArray(args));
                return;
            }
            if (shouldResetOnAdd) {
                _this.resetForm();
            }
            if (validateCart && enableValidation && !formik.isValid) {
                return;
            }
            toggleProduct.apply(void 0, _toConsumableArray(args));
        };
        _this.renderTabs = function(product, formik) {
            var ref;
            var _props = _this.props, replaceTab = _props.replaceTab, overrides = _props.overrides, stepped = _props.stepped, _stepperProps = _props.stepperProps, stepperProps = _stepperProps === void 0 ? {} : _stepperProps, shouldHideControls = _props.shouldHideControls, getRow = _props.getRow;
            var finalTabs = [];
            (ref = product.tabs) === null || ref === void 0 ? void 0 : ref.forEach(function(tab) {
                var useReplaceTabs = false;
                var currentTabRender;
                var rows = product.rows.filter(function(v) {
                    return v.tab === tab;
                }).map(getRow);
                if (isArray(replaceTab)) {
                    useReplaceTabs = replaceTab.find(function(t) {
                        return t.tabName.trim() === tab.trim();
                    });
                    currentTabRender = useReplaceTabs === null || useReplaceTabs === void 0 ? void 0 : useReplaceTabs.renderTab;
                } else {
                    useReplaceTabs = replaceTab && tab.trim() === replaceTab.tabName.trim();
                    currentTabRender = replaceTab === null || replaceTab === void 0 ? void 0 : replaceTab.renderTab;
                }
                // Skip tab if no content
                if (!rows.length && !useReplaceTabs) return;
                var tabReplacer = isArray(replaceTab) && typeof useReplaceTabs === "object" ? useReplaceTabs : replaceTab;
                var node = /*#__PURE__*/ React.createElement(Tab, {
                    key: tab
                }, useReplaceTabs ? currentTabRender === null || currentTabRender === void 0 ? void 0 : currentTabRender(product, tab, overrides, tabReplacer, formik) : stepped ? /*#__PURE__*/ React.createElement(Carousel, _extends({
                    pageSize: 1,
                    shouldHideControls: shouldHideControls
                }, stepperProps), rows.map(function(row, index) {
                    return /*#__PURE__*/ React.createElement(ProductRow, {
                        key: row.id,
                        row: row,
                        product: product,
                        overrides: overrides,
                        index: index
                    });
                })) : /*#__PURE__*/ React.createElement(Fragment, null, rows.map(function(row, index) {
                    return /*#__PURE__*/ React.createElement(ProductRow, {
                        key: row.id,
                        row: row,
                        product: product,
                        overrides: overrides,
                        index: index
                    });
                })));
                finalTabs.push({
                    label: tab,
                    node: node
                });
            });
            return /*#__PURE__*/ React.createElement(Tabs, {
                labels: finalTabs.map(function(t) {
                    return t.label;
                })
            }, finalTabs.map(function(t) {
                return t.node;
            }));
        };
        _this.resetForm = function() {
            var _props, ref;
            var _props1 = _this.props, getInitialValues = _props1.getInitialValues, productFetch = _props1.productFetch;
            if (productFetch.fulfilled) {
                var initialValues = getInitialValues(productFetch.value.rows);
                Object.entries(_this.props.formik.values).forEach(function(data) {
                    var _data = _slicedToArray(data, 2), key = _data[0], value = _data[1];
                    var clearValue = (value === null || value === void 0 ? void 0 : value.tag) ? _objectSpreadProps(_objectSpread({}, value), {
                        value: ""
                    }) : null;
                    if (clearValue) {
                        initialValues[key] = clearValue;
                    }
                });
                _this.props.formik.resetForm(initialValues);
            }
            (ref = (_props = _this.props).onReset) === null || ref === void 0 ? void 0 : ref.call(_props);
        };
        _this.onStartOverClick = function() {
            var ref = _this.props.detailStartOverConfig || {}, overrideBaseClick = ref.overrideBaseClick, onStartOverClick = ref.onStartOverClick;
            if (overrideBaseClick) {
                onStartOverClick === null || onStartOverClick === void 0 ? void 0 : onStartOverClick();
            } else {
                context.history.push("/");
                onStartOverClick && onStartOverClick();
            }
        };
        return _this;
    }
    var _proto = ProductCard.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // Revalidate form when skipRange changes
        if (prevProps.skipRange !== this.props.skipRange) {
            this.props.formik.validateForm();
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, _products = _props.products, products = _products === void 0 ? null : _products, showPrice = _props.showPrice, renderPrice = _props.renderPrice, showDescription = _props.showDescription, showAddToOrder = _props.showAddToOrder, addButtonLabel = _props.addButtonLabel, addAnotherButtonLabel = _props.addAnotherButtonLabel, addedButtonLabel = _props.addedButtonLabel, enableValidation = _props.enableValidation, viewQuoteButtonLabel = _props.viewQuoteButtonLabel, product = _props.product, flipKey = _props.flipKey, price = _props.price, canAddToCart = _props.canAddToCart, formik = _props.formik, zDepth = _props.zDepth, blockEnterSubmission = _props.blockEnterSubmission, handleChange = _props.handleChange, showHeader = _props.showHeader, showHeaderRows = _props.showHeaderRows, context = _props.context, headerRowsColors = _props.headerRowsColors, hidePriceAndDurationIfZero = _props.hidePriceAndDurationIfZero, AddToSOW = _props.AddToSOW, disabled = _props.disabled, showResetButton = _props.showResetButton, hideQuoteButton = _props.hideQuoteButton, detailStartOverConfig = _props.detailStartOverConfig, cart = _props.cart;
        var replaceQuoteWithStartOver = (detailStartOverConfig || {}).replaceQuoteWithStartOver;
        var headerRowsToShow = product.rowsInHeader ? _toConsumableArray(product.rowsInHeader) : [];
        // Temporary until we add more toggles on the core app
        var additionalHeaderRow = product.rows ? product.rows.find(function(row) {
            var ref;
            return (ref = row.description) === null || ref === void 0 ? void 0 : ref.includes("Display on the Details Page Only");
        }) : null;
        if (additionalHeaderRow && additionalHeaderRow.control) {
            headerRowsToShow.push(_objectSpreadProps(_objectSpread({}, additionalHeaderRow), {
                control: "".concat(additionalHeaderRow.label, " ").concat(additionalHeaderRow.control)
            }));
        }
        var subsequentSameItem = cart === null || cart === void 0 ? void 0 : cart.some(function(v) {
            return v.id === product.id;
        });
        var addToCartButtonLabel = subsequentSameItem ? addAnotherButtonLabel : addButtonLabel;
        var headerLabels = processHeaderLabels(headerRowsToShow);
        var pointSystem = context.state.pointSystem;
        return /*#__PURE__*/ React.createElement(Card, {
            zDepth: zDepth
        }, function(param) {
            var Header = param.Header, Body = param.Body, Footer = param.Footer;
            var _this1 = _this;
            /*#__PURE__*/ return React.createElement(Flipper, {
                flipKey: flipKey
            }, /*#__PURE__*/ React.createElement(Form, {
                onKeyPress: blockEnterSubmission
            }, /*#__PURE__*/ React.createElement(Effect, {
                onChange: handleChange
            }), showHeader && /*#__PURE__*/ React.createElement(Header, {
                sticky: context.theme.components.productDetails.header.sticky,
                divider: context.theme.components.productDetails.header.divider,
                backdrop: context.theme.components.productDetails.header.backdrop,
                flex: true
            }, /*#__PURE__*/ React.createElement(ProductData, {
                className: "product-detail-header"
            }, /*#__PURE__*/ React.createElement(MediumText, null, /*#__PURE__*/ React.createElement(Link, null, getLocalizedProperty(product, "name"))), !!tryCall(showPrice, _this.props) && renderPrice({
                props: _this.props,
                defaultRender: function(children) {
                    return /*#__PURE__*/ React.createElement(MediumText, {
                        className: "product-detail-price"
                    }, children || /*#__PURE__*/ React.createElement("p", null, pointSystem && /*#__PURE__*/ React.createElement(CoinIcon, null, /*#__PURE__*/ React.createElement(GiTwoCoins, {
                        size: 20
                    })), pointSystem ? price : formatCurrency(Number(price))));
                }
            }), Boolean(!showPrice && hidePriceAndDurationIfZero && Number(price) > 0) && /*#__PURE__*/ React.createElement(MediumText, {
                className: "product-detail-price"
            }, /*#__PURE__*/ React.createElement("p", null, pointSystem && /*#__PURE__*/ React.createElement(CoinIcon, null, /*#__PURE__*/ React.createElement(GiTwoCoins, {
                size: 20
            })), pointSystem ? price : formatCurrency(Number(price)))), Boolean(showHeaderRows) && /*#__PURE__*/ React.createElement(HeaderLabels, null, headerLabels.map(function(headerLabel, index) {
                var backgroundColor = null;
                if (!headerLabel.label) return null;
                if (headerRowsColors.length) {
                    var currentColor = headerRowsColors.find(function(color) {
                        if (headerLabel.rowLabel.includes(color.label)) return color;
                    });
                    if (currentColor) {
                        backgroundColor = currentColor.color;
                    }
                }
                return /*#__PURE__*/ React.createElement(HeaderLabel, {
                    key: index,
                    index: index + 1,
                    backgroundColor: backgroundColor || ""
                }, headerLabel.label);
            }))), AddToSOW && /*#__PURE__*/ React.createElement(AddToSOW, {
                onClick: _this.toggleProduct,
                addedToCart: !canAddToCart,
                addButtonLabel: addButtonLabel,
                addedButtonLabel: addedButtonLabel,
                product: product
            }), showAddToOrder && !AddToSOW && /*#__PURE__*/ React.createElement(ResetAndAddContainer, null, /*#__PURE__*/ React.createElement(Button, {
                onClick: _this.toggleProduct,
                type: "button",
                disabled: disabled || enableValidation && formik.submitCount > 0 && !formik.isValid,
                "data-testid": "product-details-add-button"
            }, canAddToCart ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FaPlusCircle, {
                size: 16
            }), addToCartButtonLabel) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FaMinusCircle, {
                size: 16
            }), addedButtonLabel)), showResetButton && /*#__PURE__*/ React.createElement(Button, {
                onClick: _this.resetForm,
                type: "button",
                primary: false
            }, "Reset Page"))), /*#__PURE__*/ React.createElement(Body, null, showDescription && /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
                xs: 12
            }, /*#__PURE__*/ React.createElement(MediumText, {
                className: "product-details-description-card"
            }, getLocalizedProperty(product, "description")))), !products && /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
                xs: 12
            }, _this.renderTabs(product, formik))), products === null || products === void 0 ? void 0 : products.map(function(productPromise, index) {
                var productToRender = productPromise.value;
                if (!productToRender) return null;
                return /*#__PURE__*/ React.createElement(TabsContainer, {
                    key: productToRender.id || index
                }, showDescription && /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
                    xs: 12
                }, /*#__PURE__*/ React.createElement(MediumText, {
                    className: "product-details-bundle-name"
                }, productToRender.name)), /*#__PURE__*/ React.createElement(Col, {
                    xs: 12
                }, /*#__PURE__*/ React.createElement(MediumText, {
                    className: "product-details-bundle-description"
                }, productToRender.description))), /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
                    xs: 12
                }, _this1.renderTabs(productToRender, formik))));
            })), !showAddToOrder && !hideQuoteButton && /*#__PURE__*/ React.createElement(Footer, null, /*#__PURE__*/ React.createElement(Row, null, enableValidation && Boolean(formik.submitCount) && Boolean(Object.keys(formik.errors).length) && /*#__PURE__*/ React.createElement(Col, {
                xs: 12
            }, /*#__PURE__*/ React.createElement(ErrorText, {
                shake: true
            }, i18n("productDetails.invalidFields"))), /*#__PURE__*/ React.createElement(SpacedCol, {
                xs: 12
            }, replaceQuoteWithStartOver ? /*#__PURE__*/ React.createElement(Button, {
                type: "button",
                onClick: _this.onStartOverClick
            }, i18n("productDetails.startOver")) : /*#__PURE__*/ React.createElement(Button, {
                disabled: Boolean(disabled || enableValidation && formik.submitCount && Boolean(Object.keys(formik.errors).length)),
                type: "submit"
            }, viewQuoteButtonLabel))))));
        });
    };
    return ProductCard;
}(PureComponent);
ProductCard.propTypes = {
    enableValidation: propTypes.bool,
    validateCart: propTypes.bool,
    formik: propTypes.object,
    toggleProduct: propTypes.func,
    addToCartSubmits: propTypes.bool,
    addToCartAlways: propTypes.bool,
    stepped: propTypes.bool,
    showPrice: propTypes.bool,
    renderPrice: propTypes.func,
    context: propTypes.object,
    skipRange: propTypes.object,
    products: propTypes.array,
    showDescription: propTypes.bool,
    showAddToOrder: propTypes.bool,
    addButtonLabel: propTypes.node,
    addedButtonLabel: propTypes.node,
    flipKey: propTypes.string,
    product: propTypes.object,
    price: propTypes.node,
    zDepth: propTypes.number,
    blockEnterSubmission: propTypes.func,
    addedToCart: propTypes.bool,
    handleChange: propTypes.func,
    viewQuoteButtonLabel: propTypes.node,
    showHeader: propTypes.bool,
    showHeaderRows: propTypes.bool,
    headerRowsColors: propTypes.array,
    hidePriceAndDurationIfZero: propTypes.bool,
    AddToSOW: propTypes.elementType,
    disabled: propTypes.bool,
    getRow: propTypes.func,
    showResetButton: propTypes.bool,
    onReset: propTypes.func,
    hideQuoteButton: propTypes.bool,
    getInitialValues: propTypes.func,
    detailStartOverConfig: propTypes.shape({
        replaceQuoteWithStartOver: propTypes.bool,
        onStartOverClick: propTypes.func,
        overrideBaseClick: propTypes.bool
    }),
    cart: propTypes.arrayOf(propTypes.object),
    shouldResetOnAdd: propTypes.bool,
    canAddToCart: propTypes.bool
};
ProductCard.defaultProps = {
    shouldHideControls: true,
    detailStartOverConfig: {
        replaceQuoteWithStartOver: false,
        onStartOverClick: function() {
            return null;
        },
        overrideBaseClick: false
    },
    getRow: function(v) {
        return v;
    }
};
export default withContext(ProductCard);
